import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { DataPass } from '../../types/dataPassport';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
  },
  logo: {
    width: '50%',
    display: 'grid',
    gridGap: '1px',
    placeItems: 'center',
    textAlign: 'center',
    maxWidth: '138px',

    '& img': {
      height: '72px',
      width: '72px',
    },

    '& p:last-child': {
      height: '68px',
    },
  },
  logoTitle: {
    fontSize: '10px',
  },
  logoText: {
    fontSize: '12px',
    lineHeight: '18px',
  },
});

type LogoRowProps = {
  dataPass: DataPass;
  includeVerifier: boolean;
};

const LogoRow: React.FC<LogoRowProps> = ({ dataPass, includeVerifier }) => {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      <div className={classes.logo}>
        <Typography className={classes.logoTitle}>SOURCE</Typography>
        <img src={dataPass.source_logo_url} alt={dataPass.source_description} />
        <Typography className={classes.logoText}>{dataPass.source_description}</Typography>
      </div>

      {includeVerifier && <div className={classes.logo}>
        <Typography className={classes.logoTitle}>VERIFIER</Typography>
        <img src={dataPass.verifier_logo_url} alt={`${dataPass.verifier_description} Verifier`} />
        <Typography className={classes.logoText}>{dataPass.verifier_description}</Typography>
      </div>}
    </div>
  );
};

export default LogoRow;
